import { BackOfficeReportPreview } from "@mcleod/settlement/src/BackOfficeReportPreview";
import { AutogenLayoutMiscInvoiceProcessingPrePostReview } from "./autogen/AutogenLayoutMiscInvoiceProcessingPrePostReview";
import { MiscInvoiceProcessingStepperProps } from "./MiscInvoiceProcessingStepper";
import { Api, Currency, CurrencySettings, CurrencyUtil } from "@mcleod/core";
import { ReportPreviewTabSource } from "@mcleod/components";
import { MiscInvoiceProcessingUtil } from "./MiscInvoiceProcessingUtil";

export class MiscInvoiceProcessingPrePostReview extends AutogenLayoutMiscInvoiceProcessingPrePostReview {
    public reportPreviewPrePostReview: BackOfficeReportPreview;

    override onLoad() {
        this.initializePrePostReviewPanel();
    }

    initializePrePostReviewPanel() {
        this.reportPreviewPrePostReview = new BackOfficeReportPreview("Invoice Pre-Post Review", true);
        this.panelReportPreview.add(this.reportPreviewPrePostReview);
    }

    async confirmPrint(props: MiscInvoiceProcessingStepperProps) {
        const response = await Api.post("lme/ar/confirm-misc-invoice-print", { misc_invoices: props.selectedRows });
        const data = response?.data[0];

        const totalInvoicedAmount = new Currency({ ...data?.total_invoiced_amount });
        this.labelTotalInvoicedAmount.text = CurrencyUtil.formatCurrency(totalInvoicedAmount);
        this.labelInvoiceCount.text = data?.invoice_count || "0";

        if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.labelTotalInvoicedAmountCaption.text = "Net Amount (Functional):";
            const multicurrencyTotals = data?.multicurrency_totals || [];
            MiscInvoiceProcessingUtil.populateMulticurrencyTotals(this.mainDataSource, this.panelMulticurrencyTotals, multicurrencyTotals);
        }

        const exceptionTab = MiscInvoiceProcessingUtil.createExceptionTab(data.exceptions_list);
        this.reportPreviewPrePostReview.visible = !!exceptionTab;

        if (exceptionTab) {
            this.reportPreviewPrePostReview.beginSearch();
            const tabSources: ReportPreviewTabSource[] = [
                exceptionTab
            ];
            this.reportPreviewPrePostReview.endSearch(MiscInvoiceProcessingUtil.cleanTabSources(tabSources));
        }
    }
}
